export const REQUEST_SAVE_APPLY_NOW = "REQUEST_SAVE_APPLY_NOW";
